// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__ve1RW","left-menu-wrapper":"style_left-menu-wrapper__2TFOQ","main-wrapper":"style_main-wrapper__sHvxl","right-col":"style_right-col__1F69k"};